var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"doc-viewer-page"},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:("pdf-" + (_vm.src.docId) + "-page-" + i),attrs:{"src":_vm.src,"page":i}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }